import { DateFilter, DateFilterConfig, DateFiltersEnum } from "@/@types";
import moment from "moment";

export const dateRanges: Record<
  DateFilter,
  DateFilterConfig | { date_start: string; date_end: string }
> = {
  [DateFiltersEnum.all]: {
    date_start: "",
    date_end: "",
  },
  [DateFiltersEnum.current_month]: {
    date_start: moment().startOf("month"),
    date_end: moment().endOf("month"),
  },
  [DateFiltersEnum.today]: {
    date_start: moment(),
    date_end: moment(),
  },
};

export const WeekdayTitles: { [key: string]: string } = {
  monday: "Segunda-feira",
  tuesday: "Terça-feira",
  wednesday: "Quarta-feira",
  thursday: "Quinta-feira",
  friday: "Sexta-feira",
  saturday: "Sábado",
  sunday: "Domingo",
};

export const Hours = [
  {
    title: "Segunda-feira",
    weekday: "monday",
    open: false,
    twenty_four_hours: false,
    start_time: "",
    end_time: "",
  },
  {
    title: "Terça-feira",
    weekday: "tuesday",
    open: false,
    twenty_four_hours: false,
    start_time: "",
    end_time: "",
  },
  {
    title: "Quarta-feira",
    open: false,
    weekday: "wednesday",
    twenty_four_hours: false,
    start_time: "",
    end_time: "",
  },
  {
    title: "Quinta-feira",
    weekday: "thursday",
    open: false,
    twenty_four_hours: false,
    start_time: "",
    end_time: "",
  },
  {
    title: "Sexta-feira",
    weekday: "friday",
    open: false,
    twenty_four_hours: false,
    start_time: "",
    end_time: "",
  },
  {
    title: "Sábado",
    weekday: "saturday",
    open: false,
    twenty_four_hours: false,
    start_time: "",
    end_time: "",
  },
  {
    title: "Domingo",
    weekday: "sunday",
    open: false,
    twenty_four_hours: false,
    start_time: "",
    end_time: "",
  },
];
